@if (nextButtonClicked) {
  <app-global-validation-message [formInput]="form"> </app-global-validation-message>
}
<form [formGroup]="form" class="form">
  <div class="preamble">
    <h2>Enter Reason</h2>
  </div>
  <ul class="questions">
    @if (isCompletedCategoryOrSelfAudit) {
      <li>
        <fieldset>
          @if (isNFPSelected) {
            <legend>
              <abbr title="(required)" class="required">*</abbr>
              <label for="reasonInput"> <span class="label"> {{reasonExampleInformation}}</span>
              <abbr title="(required)" class="required">*</abbr>
            </label>
          </legend>
        }
        @if (isNFPSelected) {
          <ul class="choices">
            @for (option of questionOptions; track option; let i = $index) {
              <div formArrayName="acceptedQuestions">
                <label><input type="checkbox" id="index" [formControlName]="i"/>{{option}}</label>
              </div>
            }
          </ul>
        }
      </fieldset>
    </li>
  }
  <li class="group">
    <ol class="questions">
      @if (displayReasonInputTextbox) {
        <li>
          <label for="reasonInput"> <span class="label"> {{reasonExampleInformation}}</span>
          <abbr title="(required)" class="required">*</abbr>
        </label>
        <input type="text" maxlength="255" class="col-md-8" formControlName="reasoninput" id="reasonInput" />
        @if ((nextButtonClicked || reasonInputControl.dirty) && reasonInputControl.errors != null) {
          <em class="red-alert"
            >
            Reason information required
          </em>
        }
      </li>
    }
  </ol>
</li>
</ul>

@if (isWoodChipSelected) {
  <div class="alert alert-warning">
    <p>Undertaking a native forest practice for the purpose of producing wood chips for the export market is not
    permitted under the code.</p>
  </div>
}

@if (this.isNFPSelected && !nfpReasonSelectionMade && this.nextButtonClicked) {
  <div class="alert alert-warning">
    <p>Please select.</p>
  </div>
}

@if (isSilviCulturalSelected && !isSilviCulturalPermited) {
  <div class="alert alert-warning">
    <p>Silviculture is not permitted for the activity selected.</p>
  </div>
}

<li class="footer">
  <ul class="actions">
    <li>
      <input class="qg-btn btn-global-secondary" type="button" (click)="previous()" value="Previous" />
    </li>
    <li>
      <em><input class="qg-btn btn-primary" type="submit" (click)="next()" value="Next" /></em>
    </li>
  </ul>
</li>
<ul class="actions">
  <li>
    <a href (click)="cancel()">Cancel</a>
  </li>
</ul>
</form>
